/** @jsx jsx */
/* eslint-disable no-use-before-define */
import {css, jsx} from '@emotion/core'
import React from 'react'
import { publish, STATE_NAMES, format, show, } from '../../../twd/twd';
import { getColor } from '../states-map'

const offerCss = css `
    dt, dd {
        white-space: nowrap;
        margin: 0;
        font-weight:400;
        line-height: 1.4;
    }
    dt {
        padding: 6px;
        padding-top: 0px;
    }
    dd {
        padding: 6px;
        padding-top: 0px;
        font-weight:500;
        border-bottom: 1px solid #e4e4e4;
    }
    div {
        display: grid;
        grid-template-columns: 1fr;
    }
`

export const Detail = ({
    state,
    tradeCount,
    cusipCount,
    revenueCount,
    generalObligationCount,
    avgYTM,
    avgYTW,
}) => {
    const stateName = STATE_NAMES[state]

    const [btnEl, setBtnEl] = React.useState(null)

    React.useEffect(() => {
        if (!btnEl) return

        setTimeout(() => {
            btnEl.focus()
        }, 300)
    }, [btnEl])


    return <React.Fragment>
    <div className="row vertical-offset-sm"><div className="col-md-12">
        <button
            ref={setBtnEl}
            className="close material-icons"
            aria-label="Close"
            onClick={() => { publish('hide_flyout') }}
        >close</button>
        <h3 className="text-bold" style={{display:'inline'}}>{stateName}</h3>
        &nbsp;
        {formatTradeCount(tradeCount)}
    </div></div>

    <div className="row vertical-offset-sm"><dl css={offerCss}>
        <div className="col-md-12">
        <dt>Unique CUSIPs</dt>
        <dd>{format.count(cusipCount, '-')}</dd>
        </div>
    </dl></div>

    <div className="row vertical-offset-sm"><dl css={offerCss}>
        <div className="col-md-6"  style={{paddingRight:0}}>
        <dt>General Obligation</dt>
        <dd>{format.count(generalObligationCount, format.empty())} Offerings</dd>
        </div>
        <div className="col-md-6" style={{paddingLeft:0}}>
        <dt>Revenue</dt>
        <dd>{format.count(revenueCount, format.empty())} Offerings</dd>
        </div>
    </dl></div>

    <div className="row">
    <div className="col-md-12 text-right">
        <button className="btn-link"
        data-name="municipal-map-offerings-link"
        onClick={() => {
            show("offerings", {
                searchParams: {
                    holdInvType:['M'],
                    holdState: [state],
                    persistToPreviousSearches: false,
                    offeringType: ['ask-side'],
                },
                _ts: Date.now(),
                from:'municipals/municipal-map',
            })
        }}>View State Offerings</button>
    </div></div>
    </React.Fragment>
}

const formatTradeCount = (tradeCount) => {
    let color = getColor(tradeCount)
    return <React.Fragment>
        <svg height="10" width="10">
        <circle cx="5" cy="5" r="5" stroke={color} strokeWidth="1" fill={color} />
        </svg>
        &nbsp;
        {format.count(tradeCount, format.empty())} Trades
    </React.Fragment>

}
